// extracted by mini-css-extract-plugin
export default {"cardtext__dot":"article_cardtext__dot__XOq8T","read__more":"article_read__more__xV2fP"};